import { render, staticRenderFns } from "./Usc_BAN10_AT03_R1.vue?vue&type=template&id=188ac438"
import script from "./Usc_BAN10_AT03_R1.vue?vue&type=script&lang=js"
export * from "./Usc_BAN10_AT03_R1.vue?vue&type=script&lang=js"
import style0 from "./Usc_BAN10_AT03_R1.vue?vue&type=style&index=0&id=188ac438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports